const USER_DATA_REQUEST = 'USER_DATA_REQUEST';
const USER_DATA_SUCCESS = 'USER_DATA_SUCCESS';
const USER_DATA_FAILURE = 'USER_DATA_FAILURE';
const USER_DATA_CLEAR = 'USER_DATA_CLEAR';

const initialState = {
  loading: false,
  success: false,
  failure: false,
  data: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_DATA_REQUEST:
      return {
        loading: true,
        success: false,
        failure: false,
        data: null,
      };
    case USER_DATA_SUCCESS:
      return {
        loading: false,
        success: true,
        failure: false,
        data: action.payload,
      };
    case USER_DATA_FAILURE:
      return {
        loading: false,
        success: false,
        failure: true,
        data: action.payload,
      };
    case USER_DATA_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default reducer;

/**
 * Actions
 */

export const userDataRequest = () => ({
  type: USER_DATA_REQUEST,
});

export const userDataSuccess = (payload) => ({
  type: USER_DATA_SUCCESS,
  payload,
});

export const userDataFailure = (payload) => ({
  type: USER_DATA_FAILURE,
  payload,
});

export const userDataClear = () => ({
  type: USER_DATA_CLEAR,
});
